
<script>
  import moment from 'moment'
  import http from '@/service/http'
  export default {
    name: 'relatorios',
    data () {
      return {
        orcamento_id: '',
        inicio: moment().format('YYYY-MM-01'),
        termino: moment().format('YYYY-MM-DD'),
        filtro: {
          inicio: moment().format('YYYY-MM-01'),
          termino: moment().format('YYYY-MM-DD'),
          usuario: '',
          imposto: ''
        },
        usuarios: [],
      }
    },
    mounted () {
      this.fecth()
    },
    methods: {
      formRevisao () {
        this.$router.push({name: 'relatorios.revisao', params: {id: this.orcamento_id}})
      },
      formContatosOrcamentos () {
        this.$router.push({name: 'relatorios.contatos-orcamentos', params: {inicio: this.inicio, termino: this.termino}})
      },
      formComissaoVendas () {
        this.$router.push({name: 'relatorios.contatos-orcamentos', params: {inicio: this.inicio, termino: this.termino}})
      },
      async fecth () {
        const { data } = await http.get(`/orcamentos/relatorios`)
        if (data != null) {
          this.usuarios = data.usuarios
        }
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      }
    },
    computed: {
      api_url () {
        return process.env.API_URL
      },
    }
  }
</script>

<template>
  <div>
    <div class="content">

      <div class="row">
        <div class="col s12 m7">
          <h5>Relatórios</h5>
        </div>
      </div>

      <form @submit.prevent="formContatosOrcamentos" class="row">
        <div class="row">
            <h6>Contatos X Orçamentos</h6>
            <div class="input-field col s12 m5">
              <button class="btn">Visualizar</button>
            </div>
        </div>
      </form>

      <div class="row">
        <div class="col 12">
          <h6>Revisão por orçamento</h6>
          <form @submit.prevent="formRevisao" class="row">
            <div class="col s12 m5">
              <div class="input-field inline">
                <label for="orcamento">Orcamento</label>
                <input type="number" id="orcamento" v-model="orcamento_id" required>
              </div>
            </div>
            <div class="input-field col s12 m5">
              <button class="btn">Visualizar</button>
            </div>
          </form>
        </div>
      </div>

      <h6>Comissões de Vendas</h6>
      <form :action="`${api_url}/comissao-vendas/pdf`" method="get" id="form-pdf" target="_blank">
        <div class="row">
          <div class="input-field col s12 m2">
            <i class="material-icons prefix">event</i>
            <input id="icon_inicio" type="date" name="inicio" v-model="filtro.inicio" :data-value="filtro.inicio">
            <label for="icon_inicio" class="active">Início</label>
          </div>

          <div class="input-field col s12 m2">
            <i class="material-icons prefix">event</i>
            <input id="icon_termino" type="date" name="termino" v-model="filtro.termino"
                    :data-value="filtro.termino">
            <label for="icon_termino" class="active">Término</label>
          </div>

          <div class="col s12 m2">
            <label for="usuario">Usuário</label>
            <select name="usuario" id="usuario" v-model="filtro.usuario">
              <option v-for="usuario in usuarios" :value="usuario.id">{{ (usuario.id) ? usuario.nome_completo : 'Todos' }}</option>
            </select>
          </div>

          <div class="input-field col s12 m5">
            <button class="btn">Visualizar</button>
          </div>

        </div>
      </form>

      <h6>Comissões de Serviços</h6>
      <form :action="`${api_url}/comissao-servicos/pdf`" method="get" id="form-pdf" target="_blank">
        <div class="row">
          <div class="input-field col s12 m2">
            <i class="material-icons prefix">event</i>
            <input id="icon_inicio" type="date" name="inicio" v-model="filtro.inicio" :data-value="filtro.inicio">
            <label for="icon_inicio" class="active">Início</label>
          </div>

          <div class="input-field col s12 m2">
            <i class="material-icons prefix">event</i>
            <input id="icon_termino" type="date" name="termino" v-model="filtro.termino"
                    :data-value="filtro.termino">
            <label for="icon_termino" class="active">Término</label>
          </div>

          <div class="col s12 m2">
            <label for="usuario">Usuário</label>
            <select name="usuario" id="usuario" v-model="filtro.usuario">
              <option v-for="usuario in usuarios" :value="usuario.id">{{ (usuario.id) ? usuario.nome_completo : 'Todos' }}</option>
            </select>
          </div>

          <div class="input-field col s12 m5">
            <button class="btn">Visualizar</button>
          </div>

        </div>
      </form>

      <h6>Lucro</h6>
      <form :action="`${api_url}/lucro/pdf`" method="get" id="form-pdf" target="_blank">
        <div class="row">
          <div class="input-field col s12 m2">
            <i class="material-icons prefix">event</i>
            <input id="icon_inicio" type="date" name="inicio" v-model="filtro.inicio" :data-value="filtro.inicio">
            <label for="icon_inicio" class="active">Início</label>
          </div>

          <div class="input-field col s12 m2">
            <i class="material-icons prefix">event</i>
            <input id="icon_termino" type="date" name="termino" v-model="filtro.termino"
                    :data-value="filtro.termino">
            <label for="icon_termino" class="active">Término</label>
          </div>

          <div class="input-field col s12 m2">
            <input id="imposto" type="number" step="0.01" name="imposto" v-model="filtro.imposto"
                    :data-value="filtro.imposto">
            <label for="imposto" class="active">% Imposto</label>
          </div>

          <div class="col s12 m2">
            <label for="usuario">Usuário</label>
            <select name="usuario" id="usuario" v-model="filtro.usuario">
              <option v-for="usuario in usuarios" :value="usuario.id">{{ (usuario.id) ? usuario.nome_completo : 'Todos' }}</option>
            </select>
          </div>

          <div class="input-field col s12 m5">
            <button class="btn">Visualizar</button>
          </div>

        </div>
      </form>

    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/features/relatorios/index.vue